import { useNavigate, useSearchParams } from "react-router-dom";
import React, { useEffect } from "react"
import Api from "../../utils/Api/Api";
import { Helmet } from "react-helmet";
import ShareChatAnalytics from "../../utils/ShareChatAnalytics";

export const OrderConfirmation = () => {
    const [searchParams] = useSearchParams();
    const order_id = searchParams.get("order_id");
    const status = searchParams.get("status");
    const payment_id = searchParams.get("payment_id");
    const juspay_order_id = searchParams.get("order_id"); // from Juspay

    const navigate = useNavigate();
    
    useEffect(() => {
        const checkPaymentStatus = async () => {
            try {
                // Get payment status from API using Juspay's order ID
                const params = { 
                    order_id: juspay_order_id 
                };
                const { data: confirmationData } = await Api.GetOrderConfirmation(params);
                console.log("Confirmation Data:", confirmationData);
                
                // Track payment status with Facebook Pixel
                window.fbq('track', 'Payment', {
                    status: confirmationData.status,
                    payment_id: confirmationData.payment_id,
                    order_id: confirmationData.order_id,
                    value: confirmationData.amount,
                    currency: confirmationData.currency || 'INR'
                });
                
                // Check if payment is successful based on Juspay status
                if (confirmationData.status === 'CHARGED' || 
                    confirmationData.payment_gateway_response?.resp_code === 'SUCCESS') {
                    // Track successful payment with Facebook
                    window.fbq('track', 'PaymentSuccess', {
                        value: confirmationData.amount,
                        currency: confirmationData.currency || 'INR',
                        payment_method: confirmationData.payment_method,
                        order_id: confirmationData.order_id
                    });
                    
                    // Track purchase with ShareChat
                    // ShareChatAnalytics.trackPurchase({
                    //     order_id: confirmationData.order_id,
                    //     amount: confirmationData.amount,
                    //     currency_type: confirmationData.currency || 'INR',
                    //     payment_method: confirmationData.payment_method
                    // });
                    
                    // Use the order_id from confirmation data for redirection
                    navigate(`/order?order_id=${confirmationData.order_id}`);
                } else {
                    // Track failed payment
                    window.fbq('track', 'PaymentFailed', {
                        value: confirmationData.amount,
                        currency: confirmationData.currency || 'INR',
                        reason: confirmationData.payment_gateway_response?.resp_message || 'Unknown',
                        order_id: confirmationData.order_id
                    });
                    // If payment failed, redirect to checkout with failed status
                    console.log("Payment failed, redirecting to checkout");
                    navigate('/checkout?status=failed');
                }
            } catch (err) {
                console.error("Error checking payment status:", err);
                // Track payment error
                window.fbq('track', 'PaymentError', {
                    error_type: 'api_error',
                    error_message: err.message
                });
                // If error occurs, redirect to checkout with failed status
                navigate('/checkout?status=failed');
            }
        };

        checkPaymentStatus();
    }, []);
    
    return (
        <>
            <Helmet>
                <script>
                    {`
                        fbq('track', 'CompletePayment', {
                            payment_id: '${payment_id}',
                            order_id: '${order_id}',
                            status: '${status}'
                        });
                        
                        // Track with ShareChat
                        if (window.scq) {
                            window.scq('Purchase', 'pre_defined', {
                                transaction_id: '${order_id}',
                                status: '${status}'
                            });
                        }
                    `}
                </script>
            </Helmet>
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                color: '#FAFAFA',
                fontFamily: 'Gilroy-Medium'
            }}>
                Processing your order...
            </div>
        </>
    );
}